<template>
  <amazon-delivery-card
    v-if="selectedVariant"
    v-bind="attributes"
    :product-external-id="productId"
    :product-sku="selectedVariant.id"
  />
</template>

<script setup lang="ts">
const { productId, selectedVariant } = usePdp()
const { $feature } = useNuxtApp()
const { deliveryCard: { attributes } } = useAppConfig().components.prime

if ($feature.configBuyWithPrime.src) {
  const { load, remove, status } = useScript({
    'async': true,
    'data-target-id': $feature.configBuyWithPrime.targetId,
    'src': $feature.configBuyWithPrime.src.deliveryCard,
    'type': 'module'
  }, { trigger: 'manual' })

  onMounted(async () => {
    if (status.value === 'loaded' || !$feature.configBuyWithPrime.targetId) return
    await load()
  })

  onBeforeUnmount(() => remove())
}
</script>
